(function (angular, schoolwork12) {

    'use strict';
    angular.module(schoolwork12.app.mailTemplate.name)
      .controller(schoolwork12.app.mailTemplate.controllers.editMailTemplate, [
        '$rootScope', '$scope', '$timeout', '$http', '$uibModal', '$location', '$stateParams', '$q',
         schoolwork12.app.auth.services.authentication,
         schoolwork12.app.common.services.eventNotification,
         schoolwork12.app.mailTemplate.services.mailTemplateSvc,
        function ($rootScope, $scope, $timeout, $http, $uibModal, $location, $stateParams, $q,
            authentication, eventNotification, mailTemplateSvc) {

            console.info("In edit mail template controller");
            eventNotification.subscribe(schoolwork12.app.auth.events.userLoggedIn,
                function (event, authenticatedUser) {
                    console.info('Edit mail template controller: Subscribe On UserLogin Event: '
                        .concat(angular.toJson(authenticatedUser)));

                });

            if (authentication.isAuthenticated()) {
                // school list
                $scope.schoollist = authentication.getSchools();
            }

            $scope.forms={};
            $rootScope.hideManageMailTemplate = true;
            $scope.isSearchBusy = false;
            $rootScope.showSavedSuccessMsg = false;

            $scope.validateTemplate=false;
            $scope.saveEditsClicked = false;

            //<!--alert dialog for leaving page without saving
            $scope.option2 = false;
            $scope.modalInstance2 = null;
            $rootScope.$on('$stateChangeStart', function(event, next, current) {

                if ($rootScope.showSavedSuccessMsg || !$rootScope.closeSuccess){
                    $timeout( function() {
                        $rootScope.showSavedSuccessMsg = false;
                    }, 7000);
                }

                if($scope.forms.Mail && !$scope.saveEditsClicked){
                    if($scope.forms.Mail.$dirty){
                            if(!$scope.option2){
                                $scope.openAlertEditsUnsaved();
                                event.preventDefault();
                                $rootScope.hideManageMailTemplate = true;
                            }

                            $scope.modalInstance2.result.then(function (option) {
                                $scope.option2 = option;
                                $location.url(next.url);
                            }, function () {
                            });
                    }
                }
            })

            $scope.openAlertEditsUnsaved = function () {
                $scope.modalInstance2 = $uibModal.open({
                    animation: $scope.animationsEnabled,
                    templateUrl: 'commonDialog.html',
                    windowClass: 'alert-Modal',
                    keyboard: false,
                    backdrop: 'static',
                    controller: ['$scope', '$uibModalInstance',
                    function ($scope, $uibModalInstance) {
                        $scope.ok = function () {
                            $uibModalInstance.close(true);
                        };
                        $scope.dialogMsg = 'You have un-saved changes on this page. Do you want to leave this page without saving the changes?';
                        $scope.cancel = function () {
                            $uibModalInstance.dismiss('cancel');
                        };
                    }],

                });
            };
            //-->

            //reset error messages
            $scope.editMailTemplateErrorOccurred = false;
            $scope.duplicateTemplateNameError = false;

            $scope.mailDetails = {
                templateId : $stateParams.id,
                templateName : $stateParams.templateName,
                templateType: $stateParams.templateType,
                body: $stateParams.body,
                mailSubject: $stateParams.subject,
                schoollist: $stateParams.schools,
                createdDate: moment(new Date($stateParams.created)).format('ll') ,
                modifiedDate: moment(new Date($stateParams.modified)).format('ll'),
                status: $stateParams.status,
            }


            $scope.loadInfo = ()=>{
              const mail = $scope.mailDetails;
              if (!mail.schoollist && !mail.mailSubject){
                const schoolIds = authentication.getSchools().map(school=>school.schoolId);
                mailTemplateSvc.templateSearch(authentication.getCurrentUser().keycode, {templateName: mail.templateName, schoolIds, status: 1}).then((result)=>{
                  if (result.length > 0){
                    const found = result.find(template=>template.templateId === mail.templateId);
                    if (found) {
                      $scope.mailDetails = {
                        templateId : found.templateId,
                        templateName : found.templateName,
                        templateType: found.templateType,
                        body: found.body,
                        mailSubject: found.subject,
                        schoollist: found.schoolIds,
                        createdDate: moment(new Date(found.createdDate)).format('ll') ,
                        modifiedDate: moment(new Date(found.modifiedDate)).format('ll'),
                        status: found.status,
                      }
                    }
                  }
                });

              }
            }

        //NgTagsInput Start
        $scope.allTagsAdded = [];
        $scope.loadTags = function ($query) {
            $query = $query.trim();
            var defer = $q.defer();
            $scope.schoollist = authentication.getSchools();
            var schoolList = $scope.schoollist;
            var matchingTags = $scope.schoollist;

                if($scope.allTagsAdded.length > 0){
                    matchingTags = $scope.removeDuplicatesTags(matchingTags);
                }

                if ($query.length >= 1) {
                    matchingTags = matchingTags.filter(function (item) {
                        return item.abbreviation.toLowerCase().indexOf($query.toLowerCase()) != -1;
                    });
                    if (matchingTags.length <= 0) {
                            matchingTags = [{
                                "abbreviation": "Oops, nothing found! " + "'" + $query + "'"
                            }];
                    }
                }
            defer.resolve(matchingTags);
            return defer.promise;
          };

        $scope.removeDuplicatesTags = function(tagsArray){
            // console.log("tagsArray", tagsArray)
            for(var i=1, len = $scope.allTagsAdded.length; i<len; i++){
                for(var j=1, length= tagsArray.length; j<length; j++){
                    if(tagsArray[j].abbreviation.toLowerCase() == $scope.allTagsAdded[i].abbreviation.toLowerCase()){
                        tagsArray.splice(j,0);
                        break;
                    }
                }
            }
            return tagsArray;
        };

        $scope.tagAdded = function(tag, schoolArray){
            // console.log("schoolArray", schoolArray)
            if (tag.abbreviation.indexOf("Oops, nothing found!") !== -1) {
                schoolArray.pop(tag);
            } else {
                $scope.allTagsAdded.push(tag);
            }
        };

        $scope.tagRemoved = function(tag){
            $scope.allTagsAdded = $scope.allTagsAdded.filter(function(item){
                  // console.log("tagRemoved-item", item)
                return item.abbreviation.toLowerCase() !== tag.abbreviation.toLowerCase();
            });
        };
        //NG-TAGS-INPUT END

        //settings for ckeditor
            $scope.options = {
            language: 'en',
            allowedContent: true,
            entities: false,
            removePlugins: 'elementspath',
            toolbar: 'full',
            toolbar_full: [
                {name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo']},
                {name: 'editing', items: ['Scayt']},
                {name: 'links', items: ['Link', 'Unlink']},
                {name: 'insert', items: ['Image', 'Table', 'HorizontalRule', 'SpecialChar', 'Smiley']},
                {name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-']},
                {name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike']},
                {name: 'styles', items: ['Styles', 'Format']},
                {name: 'font', items: ['Font', 'FontSize']},
                {name: 'colors', items: ['TextColor', 'BGColor']}
            ]};


            //validations on update and save call
            $scope.finish = function() {
                 var mailTemplatePromise = null;
                 $scope.duplicateTemplateNameError = false;
                 $scope.mailTemplateErrorOccurred = false;
                 $scope.editMailTemplateErrorMesg = " ";
                 console.log("Validating update template fields");

                    //templateNameRequired validation
                    if($scope.mailDetails.templateName == null || ($scope.mailDetails.templateName).trim()==''){
                        $scope.forms.Mail.$setValidity('templateNameRequired', false);
                    }
                    else{
                        $scope.forms.Mail.$setValidity('templateNameRequired', true);
                    }

                     //invalidTemplateName validation
                    var templateName = $scope.mailDetails.templateName;
                    var validTemplatePattern = /^[a-zA-Z0-9-_:/.%!?\s]+$/
                    if(templateName && !(validTemplatePattern.test(templateName))){
                        $scope.forms.Mail.$setValidity('invalidTemplateName', false);
                    }
                    else{
                        $scope.forms.Mail.$setValidity('invalidTemplateName', true);
                    }

                    //schoolNameRequired validation
                    if(!angular.isDefined($scope.mailDetails.schoollist)||$scope.mailDetails.schoollist == null|| $scope.mailDetails.schoollist.length == 0){
                        $scope.forms.Mail.$setValidity('schoolNameRequired', false);
                    }
                    else{
                        $scope.forms.Mail.$setValidity('schoolNameRequired', true);
                    }

                    //subjectRequired validation
                    if($scope.mailDetails.mailSubject == null || ($scope.mailDetails.mailSubject).trim()==''){
                        $scope.forms.Mail.$setValidity('subjectRequired', false);
                    }
                    else{
                        $scope.forms.Mail.$setValidity('subjectRequired', true);
                    }

                    //invalidSubjectName validation (includes additional pipe symbol)
                    var mailSubject = $scope.mailDetails.mailSubject;
                    var validSubjectPattern = /^[a-zA-Z0-9-_:/.%!?\s]+$/
                    if(mailSubject && !(validSubjectPattern.test(mailSubject))){
                        $scope.forms.Mail.$setValidity('invalidSubjectName', false);
                    }
                    else{
                        $scope.forms.Mail.$setValidity('invalidSubjectName', true);
                    }

                    //add error styles based on validation flags
                    $scope.validateTemplate = !$scope.forms.Mail.$valid ? true : false;

                    //map schools with user schools and get selSchoolIds
                    var selSchoolAbbr = _.pluck($scope.mailDetails.schoollist, 'abbreviation');
                    var selSchoolIds = [];
                    for (var j in $scope.schoollist) {
                     for (var i in selSchoolAbbr) {
                        if (selSchoolAbbr[i] == $scope.schoollist[j].abbreviation) {
                        selSchoolIds.push($scope.schoollist[j].schoolId);
                        }
                     }
                    }

                    var data = {
                        "templateName": $scope.mailDetails.templateName,
                        "schoolList": selSchoolIds,
                        "templateType": $scope.mailDetails.templateType,
                        "subject": $scope.mailDetails.mailSubject,
                        "body": $scope.mailDetails.body || " ",
                        "status": $scope.mailDetails.status
                    };

                    if($scope.forms.Mail.$valid){
                        $scope.isSearchBusy = true;
                        mailTemplatePromise = mailTemplateSvc.updateSchoolTemplate(authentication.getCurrentUser().keycode, data, $scope.mailDetails.templateId);
                        mailTemplatePromise
                        .then(
                                function (data) {
                                console.log("Mail template updated successfully");
                                $scope.saveEditsClicked = true;
                                $scope.isSearchBusy = false;
                                $rootScope.showSavedSuccessMsg = true;
                                $rootScope.closeSuccess = false;
                                $location.url('/manage-school-mail-templates');


                        }, function (error) {
                            console.info('Error in updating template....'.concat(angular.toJson(error)));
                            $scope.editMailTemplateErrorOccurred = true;
                            $scope.editMailTemplateErrorMesg = " ";

                            if (error.status == 400) {
                                for ( var j = 0; j < error.data._errors.length; j++) {
                                    $scope.editMailTemplateErrorMesg = $scope.editMailTemplateErrorMesg + error.data._errors[j] + "\n";
                                }

                                var checkErrorMsg = $scope.editMailTemplateErrorMesg;
                                $scope.duplicateTemplateNameError = (~checkErrorMsg.indexOf("already been used")) ? true : false;
                                $scope.editMailTemplateErrorOccurred = $scope.duplicateTemplateNameError ? false : true;

                                $scope.invalidSchoolError = (~checkErrorMsg.indexOf("valid school")) ? true : false;
                                $scope.editMailTemplateErrorOccurred = $scope.invalidSchoolError ? false : true;

                            } else if (error.status == 401 || error.status == 403) {
                                $scope.editMailTemplateErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
                            } else {
                                $scope.editMailTemplateErrorMesg = schoolwork12.app.errorMessages.internalError;
                            }

                        })['finally']
                        (function() {
                            $scope.isSearchBusy = false;
                        });

                    }

            };


setTimeout(()=>{
  $scope.loadInfo();
  }, 1000)
    }]);


}(angular, schoolwork12));
